module.exports = __webpack_public_path__ + "img/low-cost-house-1.647b03cc.jpg";